﻿const history = window.History;

function buildUpQueryString(data) {
    const queryStringData = {};
    $.map(data,
        function (value, key) {
            if (key === "isPageChange")
                return;
            if (value) {
                queryStringData[key] = value;
            }
        });
    return $.param(queryStringData).replace(/%5B%5D/g, "");
}

function getData() {
    const dataArray = $("[data-fuel-cost-query-attributes] :input").serializeArray();
    const data = {};
    dataArray.map(function (item) {
        if (data[item.name]) {
            if (typeof (data[item.name]) === "string") {
                data[item.name] = [data[item.name]];
            }
            data[item.name].push(item.value);
        } else {
            data[item.name] = item.value;
        }
    });
    return data;
}

function updateResultsLogic(isPageChange) {
    const data = getData();
    if (isPageChange) {
        data.isPageChange = true;
    }
    history.pushState(data, $("title").html(), location.pathname + "?" + buildUpQueryString(data));
    return data;
}


function triggerUpdateResults(event) {
    const currentMpg = $("#Mpg").val();
    if ($(event.target).data("autocomplete") != null)
        return;
    if (event.target.name === "FuelType") {
        $("#PencePerLitre").val("");
    }
    if (event.target.name === "Mileage") {
        if (currentMpg === "")
            return;
    }
    if (event.target.name === "ManufacturerId") {
        if (currentMpg !== "") {
            $("#Mpg").val("");
        }
        if ($("#ModelGroupId").val() != null) {
            $("#ModelGroupId").val("");
            $("#DerivativeId").val("");
        }
    }
    if (event.target.name === "ModelGroupId") {
        if (currentMpg !== "") {
            $("#Mpg").val("");
        }
        if ($("#DerivativeId").val() != null) {
            $("#DerivativeId").val("");
        }
    }
    window.updateResults();
}

function calculateExtraMpg(event) {
    event.preventDefault();
    const currentMpg = parseFloat($("#Mpg").val());
    ;
    $("#Mpg").val(currentMpg + 5);
    window.updateResults();
}

//function calculateExtra1P(event) {
//    event.preventDefault();
//    var currentPrice = parseFloat($("#PencePerLitre").val());;
//    $("#PencePerLitre").val(currentPrice + 1);
//    window.updateResults();
//}
function calculateExtra3P(event) {
    event.preventDefault();
    const currentPrice = parseFloat($("#PencePerLitre").val());
    ;
    $("#PencePerLitre").val(currentPrice + 3);
    window.updateResults();
}

function scrollToResult(event) {
    const penceperlitre = $("#PencePerLitre").val();
    const mileage = $("#Mileage").val();
    const mpg = $("#Mpg").val();
    let headerHeight = 300;
    if (window.isViewportLessThan('md')) {
        headerHeight = 120;
    }
    if (penceperlitre !== "" && mileage !== "" && mpg !== "") {
        $('html, body').animate({
            scrollTop: $("[data-fuel-cost-results-container]").offset().top - headerHeight
        }, 2000);
    }
    if (penceperlitre !== "" && mileage !== "" && mpg === "") {
        $('[data-mpg-message]').append("<div class='alert alert-danger margin-bottom-15'>Please enter mpg or choose the make, model and version for us to find it for you.</div>");
        $('html, body').animate({
            scrollTop: $('[data-mpg-section]').offset().top - headerHeight
        }, 2000);
    }
}

function reloadQuery() {
    const state = history.getState();
    $.get('/costs/new-fuel-cost-calculator/query', state.data, function (response) {
        $('[data-fuel-cost-query-attributes]').replaceWith(response);
    });
}

function updateState() { // Note: We are using statechange instead of popstate
    reloadQuery();
    const state = history.getState();
    $.get('/costs/new-fuel-cost-calculator/results', state.data, function (response) {
        $('[data-fuel-cost-results-container]').replaceWith(response);
        if (response.indexOf("fuel-cost-calculator-result") !== -1) {
            let headerHeight = 300;
            if (window.isViewportLessThan('md')) {
                headerHeight = 120;
            }
            $('html, body').animate({
                scrollTop: $("[data-fuel-cost-results-container]").offset().top - headerHeight
            }, 2000);
        }
    });
}


export function setupNewFuelCostCalculator() {
    if ($('[data-new-fuel-cost-calculator]').length) {
        $(document)
            .on("change",
                "[data-fuel-cost-query-attributes] input, [data-fuel-cost-query-attributes] select",
                triggerUpdateResults);

        $(document).on("click", "[data-recalculate-extra-mpg]", calculateExtraMpg);
        //$(document).on("click", "[data-recalculate-extra-1p]", calculateExtra1P);
        $(document).on("click", "[data-recalculate-extra-3p]", calculateExtra3P);
        $(document).on("click", "[data-view-result-button]", scrollToResult);
        // Bind to StateChange Event
        history.Adapter.bind(window, "statechange", updateState);
        window.updateResults = function () {
            updateResultsLogic();
        };
    }
}